// eslint-disable-next-line no-restricted-imports
import { SecondaryButton, SecondaryButtonProps } from '@workday/canvas-kit-react/button';
import { createComponent } from '@workday/canvas-kit-react/common';
import { secondaryButtonColors } from '@workday/wcp-cargo-react';

export const ThemedSecondaryButton = createComponent('button')({
  displayName: 'ThemedSecondaryButton',
  Component: ({ grow, ...props }: SecondaryButtonProps, ref, Element) => (
    <SecondaryButton
      ref={ref}
      as={Element}
      colors={secondaryButtonColors(props)}
      maxWidth={grow ? '100%' : undefined}
      width={grow ? '100%' : undefined}
      {...props}
    />
  ),
});
